import { createSelector } from 'reselect'
import { LabFeatureFlags } from 'constants/lab'
import { isFunnelConfigPayload } from 'lib/lab/dynamicPayload'

const DEFAULT_FEATURES: App.FunnelFeatureToggles = {
  walledGarden: true,
  roomUpgrade: true,
  luxPlus: true,
  flights: true,
  experiences: true,
  cfmr: true,
  travelProtection: true,
  carHire: true,
}

export const getFunnelFeatures = createSelector(
  (state: App.State) => state.system.features.labFlags[LabFeatureFlags.funnelOptimiser],
  (funnelFlag): App.FunnelFeatureToggles => {
    if (!funnelFlag?.enabled || !isFunnelConfigPayload(funnelFlag.value)) {
      return DEFAULT_FEATURES
    }

    return {
      walledGarden: funnelFlag.value.features?.walledGarden ?? DEFAULT_FEATURES.walledGarden,
      roomUpgrade: funnelFlag.value.features?.roomUpgrade ?? DEFAULT_FEATURES.roomUpgrade,
      luxPlus: funnelFlag.value.features?.luxPlus ?? DEFAULT_FEATURES.luxPlus,
      flights: funnelFlag.value.features?.flights ?? DEFAULT_FEATURES.flights,
      experiences: funnelFlag.value.features?.experiences ?? DEFAULT_FEATURES.experiences,
      cfmr: funnelFlag.value.features?.cfmr ?? DEFAULT_FEATURES.cfmr,
      travelProtection: funnelFlag.value.features?.travelProtection ?? DEFAULT_FEATURES.travelProtection,
      carHire: funnelFlag.value.features?.carHire ?? DEFAULT_FEATURES.carHire,
    }
  },
)
